import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { MailIcon, ArrowLeftIcon } from 'lucide-react';
export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle password reset request
    console.log({
      email
    });
    setSubmitted(true);
  };
  return <div className="min-h-screen bg-gray-50 flex flex-col" data-id="element-2525">
      <div className="flex-1 flex flex-col justify-center py-12 sm:px-6 lg:px-8" data-id="element-2526">
        <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-2527">
          <Link to="/" className="flex justify-center" data-id="element-2528">
            <div className="relative" data-id="element-2529">
              <span className="text-2xl font-bold text-blue-900" data-id="element-2530">
                Elevate<span className="text-yellow-500" data-id="element-2531">IT</span>
              </span>
              <span className="text-sm font-normal ml-0.5 text-blue-600" data-id="element-2532">
                .fr
              </span>
              <div className="absolute -bottom-1 left-0 w-full h-0.5 bg-gradient-to-r from-yellow-500 to-transparent" data-id="element-2533"></div>
            </div>
          </Link>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900" data-id="element-2534">
            {submitted ? 'Vérifiez votre email' : 'Réinitialisation du mot de passe'}
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600" data-id="element-2535">
            {submitted ? 'Si un compte existe avec cet email, vous recevrez un lien de réinitialisation.' : 'Entrez votre adresse email et nous vous enverrons un lien pour réinitialiser votre mot de passe.'}
          </p>
        </div>
        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-2536">
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10" data-id="element-2537">
            {!submitted ? <form className="space-y-6" onSubmit={handleSubmit} data-id="element-2538">
                <div data-id="element-2539">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700" data-id="element-2540">
                    Adresse email
                  </label>
                  <div className="mt-1 relative rounded-md shadow-sm" data-id="element-2541">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-2542">
                      <MailIcon className="h-5 w-5 text-gray-400" data-id="element-2543" />
                    </div>
                    <input id="email" name="email" type="email" autoComplete="email" required value={email} onChange={e => setEmail(e.target.value)} className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 text-sm" placeholder="exemple@entreprise.com" data-id="element-2544" />
                  </div>
                </div>
                <div data-id="element-2545">
                  <Button variant="secondary" fullWidth type="submit" className="shadow-sm" data-id="element-2546">
                    Envoyer les instructions
                  </Button>
                </div>
              </form> : <div className="text-center py-4" data-id="element-2547">
                <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 mb-4" data-id="element-2548">
                  <svg className="h-6 w-6 text-green-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-2549">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-2550" />
                  </svg>
                </div>
                <p className="text-sm text-gray-600 mb-4" data-id="element-2551">
                  Nous avons envoyé un lien de réinitialisation à{' '}
                  <strong data-id="element-2552">{email}</strong>. Vérifiez votre boîte de réception et
                  vos spams.
                </p>
                <Button variant="outline" onClick={() => setSubmitted(false)} className="mr-2" data-id="element-2553">
                  Réessayer
                </Button>
                <Button variant="primary" onClick={() => window.location.href = '/login'} data-id="element-2554">
                  Retour à la connexion
                </Button>
              </div>}
            <div className="mt-6" data-id="element-2555">
              <div className="relative" data-id="element-2556">
                <div className="absolute inset-0 flex items-center" data-id="element-2557">
                  <div className="w-full border-t border-gray-300" data-id="element-2558"></div>
                </div>
                <div className="relative flex justify-center text-sm" data-id="element-2559">
                  <span className="px-2 bg-white text-gray-500" data-id="element-2560">Ou</span>
                </div>
              </div>
              <div className="mt-6 text-center" data-id="element-2561">
                <Link to="/login" className="font-medium text-blue-600 hover:text-blue-500 flex items-center justify-center" data-id="element-2562">
                  <ArrowLeftIcon className="h-4 w-4 mr-1" data-id="element-2563" />
                  Retour à la page de connexion
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer className="bg-gray-50 border-t border-gray-200 py-6" data-id="element-2564">
        <div className="container mx-auto px-4" data-id="element-2565">
          <div className="text-center text-sm text-gray-600" data-id="element-2566">
            <p className="mb-2" data-id="element-2567">© 2025 ElevateIT. Tous droits réservés.</p>
            <div className="flex justify-center space-x-4" data-id="element-2568">
              <Link to="/mentions-legales" className="hover:text-blue-600" data-id="element-2569">
                Mentions légales
              </Link>
              <Link to="/politique-confidentialite" className="hover:text-blue-600" data-id="element-2570">
                Confidentialité
              </Link>
              <Link to="/cgv" className="hover:text-blue-600" data-id="element-2571">
                CGV
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>;
}